module.exports = __webpack_public_path__ + "ms-icon-310x310.png?7dbe3084dfc0d0a402769d762fb7ccd4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ms-icon-310x310.png
// module id = 228
// module chunks = 0